import React, { Component } from 'react';
import { API_BASE_URL } from "../../constants";
import { request } from "../../util/APIUtils";
import { Alert, Button, Dropdown, Icon, Menu } from "antd";
import LoadingIndicator from "../../common/LoadingIndicator";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import Table from "../../components/Table/Table";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import JobPostingDeleteModal from './JobPostingDeleteModal';
import JobPostingForm from './JobPostingForm';
import DetailModal from './DetailModal';
import './JobPosting.css';


class JobPostingList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            jobPostings: [],
            jobPosting: null,
            error: null,
            loading: false,
            page: 0,
            currentPage: 1,
            pageSize: 10,
            selectedJobPosting: null,
            add: false,
            currenUser: [],
            userId: null,
            selectedItem: null,
            totalIdList: [],
            searching: false,
            searchQuery: undefined,
            total: 0,
            size: 10,
            isEditModalOpen: false,
            addDeleteModal: false,
            mode: this.props.location.mode,
            isLoading: false,
            detailModal:false,
        };

        this.cancelJobPostingCreation = this.cancelJobPostingCreation.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.addNew = this.addNew.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleMenuClick = this.handleMenuClick.bind(this);
        this.fetchJobPostings = this.fetchJobPostings.bind(this);
        this.refreshJobPostings = this.refreshJobPostings.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.handleDetail = this.handleDetail.bind(this);
        this.toggleDetailModal = this.toggleDetailModal.bind(this);

    }

    componentDidMount() {
        this.fetchJobPostings(this.state.page, this.state.size);
    }

    fetchJobPostings(page, size, accessor, direction) {
        let sortStr = accessor ? `&sort=${accessor},${direction}` : "&sort=id,asc";
        let searchQuery = this.state.searchQuery ? `&${this.state.searchQuery}` : "";
        let url = `${API_BASE_URL}/jobPosting/fetchJobs?page=${page}&size=${size}${sortStr}${searchQuery}`;

        this.setState({ loading: true, searching: true });

        request({ url: url, method: "GET" })
            .then(response => {
             //   console.log(response.data.content);
                let totalChanged = response.data.totalElements !== this.state.total;
                this.setState({
                    page: page,
                    size: size,
                    total: response.data.totalElements,
                    jobPostings: response.data.content,
                    totalIdList: response.data.content.map(jobPosting => jobPosting.id),
                    loading: false,
                    searching: !totalChanged,
                });
            })
            .catch(error => {
                this.setState({ loading: false, searching: false, error: "İş İlanları yüklenirken bir sorun oluştu." });
                console.error(error);
            });
    }
    fetchJobDetails(jobId) {
        const url = `${API_BASE_URL}/jobPosting/${jobId}`;
        this.setState({ loading: true });

        request({ url: url, method: "GET" })
            .then(data => {
                console.log("Fetched job details:", data); // Veriyi kontrol edin
                this.setState({
                    job: data, // Burada veriyi doğru şekilde ayarladığınızdan emin olun
                    loading: false,
                });
            })
            .catch(error => {
                this.setState({ loading: false, error: "Veri çekme hatası." });
                console.error("There was an error with the fetch operation:", error);
            });
    }


    refreshJobPostings() {
        this.fetchJobPostings(this.state.page, this.state.size);
    }

    // handleJobPostingDelete = (id, jobTitle) => {
    //     const isConfirmed = window.confirm(`"${jobTitle}" Bu iş ilanını kaldırmak istediğinizden emin misiniz?`);

    //     if (isConfirmed) {
    //         const token = localStorage.getItem("accessToken");
    //         const apiUrl = `${API_BASE_URL}/jobPosting/${id}`;

    //         fetch(apiUrl, {
    //             method: "DELETE",
    //             headers: {
    //                 Authorization: "Bearer " + token,
    //             },
    //         })
    //             .then((response) => {
    //                 if (!response.ok) {
    //                     throw new Error("Network response was not ok");
    //                 }
    //                 this.setState((prevState) => ({
    //                     jobPostings: prevState.jobPostings.filter((jobPosting) => jobPosting.id !== id),
    //                 }));
    //                 this.refreshJobPostings();
    //             })
    //             .catch((error) => {
    //                 console.error("There was a problem with the fetch operation:", error.message);
    //             });
    //     }
    // };

    // handleEditJobPosting = (editedJobPosting) => {
    //     const token = localStorage.getItem("accessToken");
    //     const url = `${API_BASE_URL}/jobPosting/${editedJobPosting.id}`;
    //     let data = editedJobPosting;

    //     const params = {
    //         url: url,
    //         method: "PUT",
    //         headers: {
    //             Authorization: "Bearer " + token,
    //             "Content-Type": "application/json",
    //         },
    //         data: data,
    //     };

    //     request(params)
    //         .then((response) => {
    //             if (response.status === 200) {
    //                 const message = "İş İlanı Başarıyla Güncellendi";
    //                 Alert.success(message, {
    //                     position: 'top-right',
    //                     effect: 'stackslide',
    //                     timeout: 5000
    //                 });
    //                 this.fetchJobPostings(this.state.page, this.state.pageSize);
    //                 this.setState({ isEditModalOpen: false });
    //             } else {
    //                 const message = "İş ilanı güncellenemedi. Lütfen Tekrar Deneyiniz";
    //                 console.error("Unexpected response status", response.status);
    //                 Alert.error(message);
    //             }
    //         })
    //         .catch((error) => {
    //             const message = "İş İlanı güncellenirken bir hata oluştu. Lütfen tekrar deneyin.";
    //             console.error("İş ilanı güncellenirken bir hata oluştu:", error);
    //             Alert.error(message);
    //         });
    // };

    handleLogout() {
        this.props.handleLogout();
    }

    cancelJobPostingCreation() {
        this.setState({
            isEditModalOpen: false,
            addDeleteModal: false,
            add: false,
            detailModal:false
        });
        this.fetchJobPostings();
    }

    handleEdit(item) {
        this.setState({
            selectedJobPosting: item,
            isEditModalOpen: true,
            add: false // Yeni iş ilanı ekleme modunda olmadığımızı belirtmek için

        });
    }

    handleDetail(item) {
        console.log("Selected jobPosting for detail:", item); // Bu satırı kontrol edin
        this.setState({
            selectedJobPosting: item,
            detailModal: true
        });
    }



    toggleDetailModal() {
        this.setState(prevState => ({
            detailModal: !prevState.detailModal
        }));
    }

    handleDelete(item) {
        this.setState({
            selectedJobPosting: item,
            addDeleteModal: true,
        });
    }

    addNew(item) {
        this.setState({
            selectedJobPosting: null,
            isEditModalOpen: true,
            add: true,
        });
    }

    handleSearch(searchQuery, fromForm) {
        let page = 0;
        if (fromForm) {
            page = this.state.page;
        }
        this.setState({
            searchQuery,
            searching: true,
        }, () => this.fetchJobPostings(this.state.accessor, this.state.direction, page, this.state.size));
    }

    handleMenuClick(e) {
        if (e.key === '1') {
            this.handleEdit(this.state.selectedItem);
        } else if (e.key === '2') {
            this.handleDelete(this.state.selectedItem);
        }
    }

    render() {
        const menu = (
            <Menu onClick={this.handleMenuClick}>
                {
                    this.state.selectedItem &&
                    <Menu.Item key="1">
                        İş İlanını Düzenle
                    </Menu.Item>
                }
                {
                    this.state.selectedItem &&
                    <Menu.Item key="2">
                        İş İlanını Kaldır
                    </Menu.Item>
                }
            </Menu>

        );

        const columns = [
            {
                Header: "Görev Adı",
                accessor: "item",
                Cell: ({ jobTitle  }) => (
                    <a href="#" onClick={() => this.handleDetail(jobTitle)}>
                        {jobTitle}
                    </a>
                )
            },
            {
                Header: "Görev Tanımı",
                accessor: "jobDescription"
            },
            {
                Header: "Başvuru Açılış Tarihi",
                accessor: "postedDate",
                Cell: (item) => (
                    <label>{new Date(item.postedDate).toLocaleDateString("tr")}</label>
                ),
            },
            {
                Header: "Başvuru Bitiş Tarihi",
                accessor: "expiryDate",
                Cell: (item) => (
                    <label>{new Date(item.expiryDate).toLocaleDateString("tr")}</label>
                ),
            },


            {
                Header: "İletişim Bilgileri",
                accessor: "contactInfo"
            },
            {
                Header: "Eczane Adı",
                accessor: "pharmacy",
                Cell: ({ pharmacy }) => (
                    <label>{pharmacy && pharmacy.name ? pharmacy.name : "Bilinmiyor"}</label>
                ),
            },
            {
                Header: "İşlemler",
                accessor: "",
                sortable: false,
                Cell: item => (
                    <div>
                        <Dropdown overlay={menu} trigger='click' onClick={() => this.setState({ selectedItem: item })}>
                            <Button style={{
                                background: '#3b6b96',
                                height: '30px',
                                width: '100px',
                                color: 'white',
                                borderRadius: '0.375em',
                                fontSize: "12px",
                            }}>
                                Seçiniz<Icon type="down" />
                            </Button>
                        </Dropdown>
                    </div>
                )
            }
        ];

        const fields = [
            {
                label: "Görev Adı",
                accessor: "jobTitle",
                type: "text",
                operator: "=",
            },
            {
                label: "Görev Açıklaması",
                accessor: "jobDescription",
                type: "text",
                operator: "=",
            },
            {
                label: "İş İlanı Yayınlanma Tarihi",
                accessor: "postedDate",
                type: "date",
                operator: "=",
            },
            {
                label: "İş İlanı Yayın Bitiş Tarihi",
                accessor: "expiryDate",
                type: "date",
                operator: "=",
            },
            {
                label: "İş İlanı Yayınlayan Eczane ",
                accessor: "pharmacy.name",
                type: "text",
                operator: "=",
            },
        ];

        return (
            <div className="row baseBackground">
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator />
                    </div>
                }

                <div className="col-md-12 satirBasi">
                    <div className="card-header">
                        <h4 className="card-title">İş İlanları</h4>
                    </div>
                    <div className="card-body mt-1">
                        <div className="">
                            <div className="" style={{ marginTop: "10px", marginBottom: "10px" }}>
                                <DetailedSearch
                                    fields={fields}
                                    loading={this.state.searching}
                                    onSearch={this.handleSearch}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <Table
                            loading={this.state.loading}
                            loadingText="Kayıtlar getiriliyor..."
                            content={this.state.jobPostings}
                            total={this.state.total}
                            page={this.state.page}
                            size={this.state.size}
                            options={["5", "10", "20", "50", "100"]}
                            columns={columns}
                            fetchData={this.fetchJobPostings}
                            style={{ width: "100%" }}
                        />
                    </div>
                    <div className='new-button-holder'>
                        <button type='button' data-toggle="tooltip" data-placement="bottom" title='Yeni İş İlanı Oluştur' disabled={this.state.isLoading}
                             style={{
                                background: 'linear-gradient(#2b93cd, #0a66b7)',
                                height: '40px',
                                width: '160px',
                                float: 'right',
                                marginRight: '30px',
                                color: 'white',
                                borderRadius: '0.375em',
                            }}
                            className="TekBtn add-new-member "
                            rel="tooltip"
                            onClick={() => this.addNew(this.state.selectedItem)}
                        >
                            YENİ İŞ İLANI OLUŞTUR
                        </button>
                    </div>
                </div>
                <Modal isOpen={this.state.isEditModalOpen} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelJobPostingCreation}>
                        {this.state.add ? 'Yeni İş İlanı Oluştur' : 'İş İlanı Düzenle'}
                    </ModalHeader>
                    <ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                        <JobPostingForm
                            cancelProcess={this.cancelJobPostingCreation}
                            jobPosting={this.state.selectedJobPosting}
                            currentUser={this.props.currentUser}
                            mode={this.state.mode}
                            module={this.props.jobTitle}
                            handleSearch={this.handleSearch}
                            searchQuery={this.state.searchQuery}
                            handleLogout={this.handleLogout}
                            onClose={() => this.setState({ isEditModalOpen: false, jobPosting: null })}
                            add={this.state.add}
                        />
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.addDeleteModal} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelJobPostingCreation}>
                        İş İlanı Kaldırma
                    </ModalHeader>
                    <ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                        <JobPostingDeleteModal
                            cancelProcess={this.cancelJobPostingCreation}
                            jobPosting={this.state.selectedJobPosting}
                            handleLogout={this.handleLogout}
                            refreshJobPostings={this.refreshJobPostings}
                        />
                    </ModalBody>
                </Modal>



                <Modal isOpen={this.state.detailModal} size="lg" className="ust" toggle={this.toggleDetailModal}>
                    <ModalHeader toggle={this.toggleDetailModal}>
                        İş İlanı Detay Sayfası
                    </ModalHeader>
                    <ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                        <DetailModal
                            cancelProcess={this.cancelJobPostingCreation}
                            jobPosting={this.state.selectedJobPosting}
                            handleLogout={this.handleLogout}
                            refreshJobPostings={this.refreshJobPostings}
                        />
                    </ModalBody>
                </Modal>

            </div>
        )
    }
}

export default JobPostingList;



// WEBPACK FOOTER //
// ./src/page/jobPosting/JobPostingList.js